import { render } from "./SearchCustomerModal.vue?vue&type=template&id=7da9795e"
import script from "./SearchCustomerModal.vue?vue&type=script&lang=js"
export * from "./SearchCustomerModal.vue?vue&type=script&lang=js"
script.render = render

export default script